import { Component, OnInit, ViewChild, Injector, signal, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckPaymentService } from 'src/app/adapters/checkPayment.service';
import { TiscoModalComponent } from 'src/app/shared/component/tisco-modal/tisco-modal.component';
import { EntryTransactionPaymentService } from 'src/app/adapters/entryTransactionPayment.service';
import { GetInsuranceRenewMotorService } from 'src/app/adapters/getInsuranceRenewMotor.service';
import { UpdatePaymentDetailService } from 'src/app/adapters/updatePaymentDetail.service';
import { formatDate } from '@angular/common';
import { SendLineMessageService } from 'src/app/adapters/sendLineMessage.service';
import { environment } from 'src/environments/environment';
import { CallTss } from 'src/app/adapters/callTss.service';
import { GetMotorPaymentSummary } from '../../adapters/getMotorPaymentSummary.service';
import { GetNonMotorPaymentSummary } from '../../adapters/getNonMotorPaymentSummary.service';
import { ConstantsService } from '../../shared/service/constants/constants.service';
import { BaseComponents } from '../../base.component';
import { ConvertTimestamp } from '../../adapters/convertTimestamp.service';

import liff from '@line/liff';
declare var window: any;

@Component({
  selector: 'app-payment-callback',
  templateUrl: './payment-callback.component.html',
  styleUrls: ['./payment-callback.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone:false
})
export class PaymentCallbackComponent extends BaseComponents implements OnInit {
  @ViewChild(TiscoModalComponent) modal;

  loading = signal<boolean>(false);
  paymentObj = {};
  transactionId: string;
  paymentMethod: string;
  cardNumber: string;
  result: string;
  failDesc: string;
  mockText = signal<string>('กรุณารอระบบกำลังประมวลผล')
  prepareData = {};
  product_type: number;
  isMotor = true;
  liff_id: string;
  profile: any;
  // lineId: string;
  f09Status: number;
  // access_token_line : string = ""
  liff_channel_id : string = "";
  channel_line_id : string = "";
  logger_text = "";
  subChannel: number | null = null;
  isCompulsory: boolean = false;

  constructor(
    protected injectorObj: Injector,
    private route: ActivatedRoute,
    private router: Router,
    private checkPaymentService: CheckPaymentService,
    private entryTransactionPaymentService: EntryTransactionPaymentService,
    private getInsuranceRenewMotorService: GetInsuranceRenewMotorService,
    private updatePaymentDetail: UpdatePaymentDetailService,
    private sendLineMessageService: SendLineMessageService,
    private callTss: CallTss,
    private getMotorPaymentSummary: GetMotorPaymentSummary,
    private getNonMotorPaymentSummary: GetNonMotorPaymentSummary,
    private ConstantsService: ConstantsService,
    private convertTimestamp: ConvertTimestamp,
  ) {
    super(injectorObj);
   }

  async ngOnInit() {
    this.loading.set(true);
    this.oninitParamRouter();
    try {
      this.getInsuranceRenewMotor();
      // await liff.init({ liffId: this.liff_id })
      // if(liff.isLoggedIn() === false && liff.isInClient() === false){
      //   this.logger.info([this.logger_text,'payment-callback login liff callback path:', window.location.href]);
      //   liff.login({ redirectUri: window.location.href })
      // }else{
      //   this.access_token_line = await liff.getAccessToken();
      //   this.logger.debug([this.logger_text,'payment-callback access_token_line:', this.access_token_line]);        
      //   this.getInsuranceRenewMotor();      
      // }       
    }
    catch (error) {
      this.logger.error(`payment-callback get line error: ${error?.message}`);
      if (error.code === '401' || error?.message === "The access token expired" || error?.message === "Load failed" || error?.message === "access_token is required") {
        this.logger.error([this.logger_text,'error line_token payment-callback :', error?.message]);
        liff.logout()
        liff.login({ redirectUri: window.location.href })
        } else {
          this.logger.error(`${this.logger_text} error payment-callback ${error?.message}`);
          this.router.navigate(['/renewal/page-error']);
        }
    };
    if (environment.log_level == 'debug') {
      window.vConsole = new window.VConsole();
    }
  }

  oninitParamRouter() {
    const params = this.route.snapshot.queryParamMap['params']
    this.logger.info(['payment-callback oninitParamRouter:', params]);
    this.transactionId = this.route.snapshot.queryParamMap['params'].transaction_id || '';
    this.paymentMethod = this.route.snapshot.queryParamMap['params'].payment_method || '';
    this.cardNumber = this.route.snapshot.queryParamMap['params'].card_number || '';
    this.result = this.route.snapshot.queryParamMap['params'].result || '';
    this.failDesc = this.route.snapshot.queryParamMap['params'].fail_desc || '';

    // this.liff_id = this.paymentObj['liffId'];
    this.liff_channel_id = this.route.snapshot.queryParamMap['params'].liff_channel_id;
    this.channel_line_id = this.route.snapshot.queryParamMap['params'].channel_line_id;
    this.liff_id = this.route.snapshot.queryParamMap['params'].liffId;
    this.logger.info(['payment-callback liff_id:', this.liff_id]);
    this.logger.info(['payment-callback liff_channel_id:', this.liff_channel_id]);
    this.logger.info(['payment-callback channel_line_id:', this.channel_line_id]);
    this.logger.info(['payment-callback result:', this.result]);
    this.logger.info(['payment-callback this.route.snapshot.params', this.route.snapshot.params]);

    const urlPaymentObj = this.route.snapshot.params.paymentObj.split('?');
    this.logger.info(['payment-callback urlPaymentObj', urlPaymentObj]);
    let paymentObjEncryped = urlPaymentObj[0];
    this.transactionId = urlPaymentObj[1] ? urlPaymentObj[1].replace("transaction_id=", "") : '';
    this.logger.info('payment-callback this.transactionId', this.transactionId);
    this.logger.info('payment-callback paymentObjEncryped', paymentObjEncryped);
    this.paymentObj = this.unpacker(paymentObjEncryped);
    this.subChannel = this.paymentObj["subchannel"] ? parseInt(this.paymentObj["subchannel"]) : null
    this.logger.info(['payment-callback subchannel: ',this.subChannel]);
    this.logger.info('payment-callback paymentObj', this.paymentObj);
    this.product_type = parseInt(this.paymentObj['product_type']) || null;
    // this.logger.info("product type", this.product_type, this.ConstantsService.MOTOR, this.product_type == this.ConstantsService.MOTOR);
    if (this.product_type == this.ConstantsService.MOTOR) {
      this.isMotor = true;
      this.logger_text = "Callback Credit card Motor:"
    } else {
      this.isMotor = false;
      this.logger_text = "Callback Credit card Non-Motor:"
    }

    this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "result", this.result]);
  }

  packer(o) {
    const str = JSON.stringify(o);
    const mess = btoa(str);
    return mess.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, ',');
  }

  unpacker(str) {
    try {
      let mess = str.replace(/-/g, '+').replace(/_/g, '/').replace(/,/g, '=');
      mess = atob(mess);
      return JSON.parse(mess);
    } catch (error) {
      this.logger.error('payment-callback unpacker error:',error.message);
      this.loading.set(false);
      this.modal.show({
        title: 'Header Information',
        callBack: 'home',
        body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
      });
    }
  }

  populateBodyTransaction(isSuccess = true) {
    let data = {
      "BKIStatus": isSuccess ? 'Y' : 'N',
      "accountIdentityUCID": this.paymentObj['accountIdentityUCID'],
      "identityUCID": this.paymentObj['identityUCID'],
      "orderTransactionUCID": this.paymentObj['orderTransactionUCID'],
      "paymentDetailID": this.paymentObj['paymentDetailID'],
      "orderNumber": this.paymentObj['orderNumber'],
      "productInfoUCID": this.paymentObj['productInfoUCID'],
      "voucherNumber": this.paymentObj['voucherNumber'],
      "securitiesID": 'RENEW',
      "unitPrice": null,
      "amount": this.paymentObj['amount'],
      "switchingInOutSecurities": null,
      "transactionId": this.transactionId,
      "transactionStatus": 1,
      "orderStatus": isSuccess ? 5 : 6,
      "paymentStatus": isSuccess ? 5 : 6,
      "renewMotor": true,
    };
    return data;
  }

  async createOrderTransactionCalled(bodyTransaction, result_1_2936, result_1_2937, result_1_2939) {
    const result = await this.createOrderTransaction(bodyTransaction);
    // this.loading = false
    this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "create order transaction res", result]);
    if (result.status) {
      this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "get payment summary"]);
      let body_get_payment_summary = this.createBodyGetPaymentSummary();
      let responseGetPaymentSummary = null;
      if (this.isMotor) {
        responseGetPaymentSummary = await this.getMotorPaymentSummary.exec(body_get_payment_summary);
      } else {
        responseGetPaymentSummary = await this.getNonMotorPaymentSummary.exec(body_get_payment_summary);
      }

      this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "update customer account 52"]);
      const prepareData = await this.populatePrepareData(result_1_2936, result_1_2937, result_1_2939, responseGetPaymentSummary);
      this.logger.debug(['prepareData==>', prepareData]);
      // PRE STEP3 Update before call TSS
      this.f09Status = 52;
      const prePopulatePayment = this.populatePaymentDetail(result_1_2937);
      this.logger.info('prePopulatePayment', prePopulatePayment);
      await this.updatePaymentDetailCalled(prePopulatePayment);
      // STEP3
      this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "call f09 50"]);
      await this.callTssService(prepareData);
      // STEP4
      const populatePayment = this.populatePaymentDetail(result_1_2937);
      this.logger.info('populatePayment', populatePayment);
      await this.updatePaymentDetailCalled(populatePayment);
      if (this.result == 'success') {
        this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "Send line 006"]);
        // Send Line
        const populateLineMessage = this.populateSendLineMessage();
        this.logger.info('populateLineMessage', populateLineMessage);
        await this.sendLineMessage(populateLineMessage);

        // Send Line
        this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "Send line 007"]);
        const populateLineMessage007 = this.populateSendLineMessage007();
        this.logger.info('populateLineMessage007', populateLineMessage007);
        await this.sendLineMessage(populateLineMessage007);
        this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "Success all flow"]);
      } else {
        this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "Send line 010"]);
        const populateLineMessage010 = this.populateSendLineMessage010();
        this.logger.info('populateLineMessage010', populateLineMessage010);
        this.sendLineMessage(populateLineMessage010);
      }
    } else {
      this.logger.info([this.logger_text,"createOrderTransaction error status is false"]);
      this.loading.set(false);
      this.modal.show({
        title: 'Header Information',
        callBack: 'home',
        body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
      });
    }
  }


  getInsuranceRenewMotor() {
    this.logger.info([this.logger_text,"call service insuranceRenewMotor start"]);

    this.getInsuranceRenewMotorService.exec({ renewMotorUCID: this.paymentObj['renewMotorUCID'], renewMotorLetterUCID: this.paymentObj['renewMotorLetterUCID'], isMotor: this.isMotor }).then(async (res) => {
    this.logger.debug('getInsuranceRenewMotorService', res);
      if (res['status'] === true) {
        this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "get renew info"]);
        this.isCompulsory = res['isCompulsory'];
        // this.result = "Fail"; // use for test
        const result_1_2936 = res['result_1_2936'] ? res['result_1_2936'].data[0] ? res['result_1_2936'].data[0] : undefined : undefined;
        const result_1_2937 = res['result_1_2937'] ? res['result_1_2937'].data[0] ? res['result_1_2937'].data[0] : undefined : undefined;
        const result_1_2953 = res['result_1_2953'] ? res['result_1_2953'].data[0] ? res['result_1_2953'].data[0] : undefined : undefined;
        const result_1_2954 = res['result_1_2954'] ? res['result_1_2954'].data[0] ? res['result_1_2954'].data[0] : undefined : undefined;
        const result_1_2939 = res['result_1_2939'].data ? res['result_1_2939'].data[0] : undefined;
        // const result_1_9 = res['result_1_9'].data[0]
        // const result_1_424 = res['result_1_1424'].data[0]
        // this.paymentObj['amount'] = result_1_2937._10966
        this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "create order transaction"]);
        const bodyTransaction = this.populateBodyTransaction(this.result == 'success' ? true : false);
        // this.logger.info('bodyTransaction', bodyTransaction);
        if(this.isMotor){
          this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "create order transaction motor start"]);
          this.createOrderTransactionCalled(bodyTransaction, result_1_2936, result_1_2937, result_1_2939);
        }else{
          this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "create order transaction non-motor start"]);
          this.createOrderTransactionCalled(bodyTransaction, result_1_2953, result_1_2954, result_1_2939);
        }
      }
      else {
        this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "cannot get data"]);
        this.loading.set(false);
        this.modal.show({
          title: 'Header Information',
          callBack: 'home',
          body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
        });
      }
    }).catch((e) => {
      this.loading.set(false);
      this.logger.error("error getInsuranceRenewMotor: ", e.message);
      this.modal.show({
        title: 'Header Information',
        callBack: 'home',
        body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
      });
    });
  }


  updatePaymentDetailCalled(populatePayment): Promise<any> {
    return this.updatePaymentDetail.exec(populatePayment).then(async (res) => {
      this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "update customer account, res", res]);
      if (res['status'] === true) {
        if (this.result != 'success') {
          this.openUrl('waiting-payment', {
            ...this.route.snapshot.queryParams
          });
          return;
        }
      }
      else {
        this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "updatePaymentDetailCalled error status is false"]);
        this.modal.show({
          title: 'Header Information',
          callBack: 'home',
          body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
        });
      }
    }).catch((e) => {
      this.loading.set(false);
      this.logger.error("error updatePaymentDetailCalled: ", e);
      this.modal.show({
        title: 'Header Information',
        callBack: 'home',
        body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
      });
    });
  }

  async sendLineMessage(populateLineMessage) {
    this.sendLineMessageService.exec(populateLineMessage).then(async (res) => {
      this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "Send line res", res]);
      if (res['status'] === true) {
        // // TODO: SUCCESS CASE
        // LOCAL
        this.mockText.set('ชำระสำเร็จกรุณาปิดหน้านี้');
        liff.closeWindow();
      }
      else {
        this.mockText.set(res['data'].message ? res['data'].message : 'Unexpected Error');
        this.modal.show({
          title: 'Header Information',
          callBack: 'home',
          body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
        });
      }
      this.loading.set(false);
    }).catch((e) => {
      this.loading.set(false);
      this.logger.error("error sendLineMessage: ", e);
      this.modal.show({
        title: 'Header Information',
        callBack: 'home',
        body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
      });
    });
  }

  populateSendLineMessage = () => {

    let templateRef = this.isCompulsory ? 'Renew-006-MOTOR-COMP' : 'Renew-006-MOTOR';
    if (this.product_type == this.ConstantsService.NONMOTOR) {
      templateRef = 'Renew-006-NONMOTOR';
    }

    const populateLine = {      
      channelId: this.paymentObj['channelId'] ? this.paymentObj['channelId'] : '279',
      liff_channel_id: this.liff_channel_id,
      channel_line_id: this.channel_line_id,
      templateRef: templateRef,
      templateParameter: {
        "message": "987654321"
      },
      message: []
    };
    return populateLine;
  };

  populateSendLineMessage007 = () => {
    let templateRef = this.isCompulsory ? 'Renew-007-MOTOR-COMP' : 'Renew-007-MOTOR';
    if (this.product_type == this.ConstantsService.NONMOTOR) {
      templateRef = 'Renew-007-NONMOTOR';
    }

    const populateLine = {      
      channelId: this.paymentObj['channelId'] ? this.paymentObj['channelId'] : '279',
      liff_channel_id: this.liff_channel_id,
      channel_line_id: this.channel_line_id,
      templateRef: templateRef,
      templateParameter: {
        "message": "987654321"
      },
      message: []
    };
    return populateLine;
  };

  populateSendLineMessage010 = () => {
    let templateRef = this.isCompulsory ? 'Renew-010-MOTOR-COMP' : 'Renew-010-MOTOR';
    if (this.product_type == this.ConstantsService.NONMOTOR) {
      templateRef = 'Renew-010-NONMOTOR';
    }

    const populateLine = {      
      channelId: this.paymentObj['channelId'] ? this.paymentObj['channelId'] : '279',
      liff_channel_id: this.liff_channel_id,
      channel_line_id: this.channel_line_id,
      templateRef: templateRef,
      templateParameter: {
        "message": "987654321"
      },
      message: []
    };
    return populateLine;
  };

  populatePaymentDetail = (result_1_2937) => {
    const popputlatePayment = {
      _13438: result_1_2937._13438 ? result_1_2937._13438 : null,
      f09Status: this.f09Status,
      paymentType: 1,
      // payment: null,
      paymentStatus: this.result === 'success' ? true : false,
      amount: this.paymentObj['amount'],
      renewMotorUCID: this.paymentObj['renewMotorUCID'],
      product_type: this.product_type,
      subchannel: this.subChannel
    };
    return popputlatePayment;
  };

  populatePrepareData = async (result_1_2936, result_1_2937, result_1_2939, PaymentSummary) => {
    // let now = new Date(result_1_2936._601);
    // let DD = now.getDate();
    // let MM = now.getMonth() + 1;
    // let YYYY = now.getFullYear();
    // let DD_str: string = DD < 10 ? `0${DD}` : `${DD}`;
    // let MM_str: string = MM < 10 ? `0${MM}` : `${MM}`;
    // let YYYY_str: string = `${YYYY.toString()}`;
    // let lead_date = `${DD_str}/${MM_str}/${YYYY_str}`;

    let lead_date_str = ""
    this.logger.info([this.logger_text,  this.paymentObj['renewMotorUCID'],  "lead date", result_1_2936._601]);
    let convet_time_result: any = await this.convertTimestamp.exec({input_date: result_1_2936._601});
    this.logger.info([this.logger_text,  this.paymentObj['renewMotorUCID'], "lead date raw", convet_time_result]);
    if(convet_time_result.response_code === "40000"){
      lead_date_str = convet_time_result.response_data;
    }

    this.logger.info([this.logger_text,  this.paymentObj['renewMotorUCID'], "lead date str", lead_date_str]);

    
    let today = new Date().getTime();
    this.logger.info([this.logger_text,  this.paymentObj['renewMotorUCID'], "today", today]);
    let today_str = "";
    let convet_time_result_today: any = await this.convertTimestamp.exec({input_date: today});
    this.logger.info([this.logger_text,  this.paymentObj['renewMotorUCID'], "lead date raw today", convet_time_result_today]);
    if(convet_time_result_today.response_code === "40000"){
      today_str = convet_time_result_today.response_data;
    }
    
    this.logger.info([this.logger_text,  this.paymentObj['renewMotorUCID'], "today str", today_str]);
    // const formatedDate = formatDate(new Date(), 'dd/MM/yyyy', 'en-US');
    const prepareData = {
      app_code: this.product_type == this.ConstantsService.MOTOR ? result_1_2936._12201 : result_1_2936._6229,
      account_no: this.product_type == this.ConstantsService.MOTOR ? result_1_2936._16055 : result_1_2936._40,
      lead_date: lead_date_str,
      client_no: result_1_2936._15812,
      classify_insure: this.isMotor ? '1' : '2',
      f09_update_inform: '50',
      quotation_selected: this.product_type == this.ConstantsService.MOTOR ? result_1_2937._13438 : undefined,
      payment_type: '1',
      payment_method: result_1_2936._13249,
      payment_status: this.result == 'success' ? true : false,
      payment_amount: this.paymentObj['amount'],
      payment_summary: PaymentSummary.data ? PaymentSummary.data : "",
      payment_date: today_str,
      agent1: result_1_2939 ? result_1_2939._11784 : null,
      agent2: result_1_2939 ? result_1_2939._16220 : null
    };

    let body_log = {
      app_code: prepareData.app_code,
      account_no: prepareData.account_no,
      lead_date: prepareData.lead_date,
      payment_date: prepareData.payment_date,
      classify_insure: prepareData.classify_insure,
      payment_status: prepareData.payment_status,
      f09_update_inform : prepareData.f09_update_inform,
      client_no : prepareData.client_no,
      quotation_selected : prepareData.quotation_selected,
      payment_method: prepareData.payment_method      
    }

    this.logger.info([this.logger_text,  this.paymentObj['renewMotorUCID'], "f09 body", body_log]);
    return prepareData;
  };


  callTssService(bodyTss): Promise<any> {
    this.f09Status = 51;
    return this.callTss.exec(bodyTss).then((res: any) => {
      this.logger.info([this.logger_text, this.paymentObj['renewMotorUCID'], "call f09 50 res", res]);
      // this.logger.info('callTssService res', res);
      if (res.response_code === '40000') {
        this.f09Status = 50;
        return { status: true, data: res };
      } else {
        return { status: false, data: res };
      }
    }).catch((e) => {
      this.logger.error("error callTssService: ", e.message);
      return { status: false, data: e };
    });
  }

  createOrderTransaction(bodyTransaction): Promise<any> {
    return this.entryTransactionPaymentService.exec(bodyTransaction).then((res: any) => {
      if (res.messageCode === '30000') {
        return { status: true, data: res };
      } else {
        return { status: false, data: res };
      }
    }).catch((e) => {
      this.logger.error("error createOrderTransaction: ", e.message);
      return { status: false, data: e };
    });
  }


  async openUrl(url: string, params: any = {}) {
    this.router.navigate([url], { queryParams: params });
  }


  createBodyGetPaymentSummary() {
    return {
      "dataucid": this.paymentObj['renewMotorUCID'],
      "letterucid": this.paymentObj['renewMotorLetterUCID']
    };
  }


}
